(ns manage.adset-decision-tree-page.tagging-and-trackers.ocp
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [clojure.string :as str]
            [common.ocp.view :refer [defocp ocp]]
            [common.ui.tabs :refer [tabs]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.selection :as selection]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.tagging-and-trackers.meta-pixel.db :as meta-pixel.db]
            [manage.adset-decision-tree-page.tagging-and-trackers.meta-pixel.view :as meta-pixel.view]
            [manage.adset-decision-tree-page.tagging-and-trackers.tagging.db :as tagging.db]
            [manage.adset-decision-tree-page.tagging-and-trackers.tagging.view :as tagging.view]
            [manage.adset-decision-tree-page.tagging-and-trackers.tracker.db :as tracker.db]
            [manage.adset-decision-tree-page.tagging-and-trackers.tracker.view :as tracker.view]
            [manage.adset-decision-tree-page.view.hook :as hook]
            [manage.adset.hooks :as adset.h]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-db ::init
  (fn [db [_ tagging trackers meta-pixel]]
    (assoc db
           ::tagging.db/tagging-params (->> tagging
                                            (mapv (fn [{:keys [name values]}]
                                                    [name (first values)])))
           ::tracker.db/tracker-params (or trackers [])
           ::meta-pixel.db/meta-pixel (get-in meta-pixel [0 :value] ""))))

(rf/reg-event-db ::destroy
  (fn [db _]
    (dissoc db
            ::tagging.db/tagging-params
            ::tracker.db/tracker-params
            ::meta-pixel.db/meta-pixel)))

(defhook use-initial-values [selected-item]
  (let [[initial-tagging] (hook/use-selected-item-data-path
                           {:selected-item selected-item
                            :data-path property/tagging-data-path})
        [initial-trackers] (hook/use-selected-item-data-path
                            {:selected-item selected-item
                             :data-path property/trackers-data-path})
        [initial-meta-pixel] (hook/use-selected-item-data-path
                              {:selected-item selected-item
                               :data-path property/meta-pixel-data-path})]
    {:tagging initial-tagging
     :trackers initial-trackers
     :meta-pixel initial-meta-pixel}))

(defn get-summary [{:keys [tagging trackers meta-pixel]}]
  (let [summary (->> [(when (pos? (count tagging))
                        "UTM tagging")
                      (when-let [tracker-count (some->> (seq trackers) count)]
                        (str tracker-count " tracker" (when (< 1 tracker-count) "s")))
                      (when-not (str/blank? (:value (first meta-pixel)))
                        "Meta Pixel")]
                     (remove nil?)
                     (str/join " and "))]
    (when-not (str/blank? summary)
      (str summary " configured"))))

(defocp ocp-view ::ocp {:width "50%"}
  [{:keys [selected-item]
    {initial-tagging :tagging
     initial-trackers :trackers
     initial-meta-pixel :meta-pixel} :initial-values}]
  (let [form-tagging (use-subscribe [::tagging.db/tagging-params])
        form-trackers (use-subscribe [::tracker.db/tracker-params])
        form-meta-pixel (use-subscribe [::meta-pixel.db/meta-pixel])
        can-save-form (tracker.db/use-can-save-trackers)
        host-node-id (selection/get-host-node-id selected-item)
        host-node-data (use-subscribe [::sub/node-data host-node-id])
        current-channel (adset.h/use-channel)]
    (uix/use-effect (fn []
                      (rf/dispatch [::init initial-tagging initial-trackers initial-meta-pixel])
                      #(rf/dispatch [::destroy]))
                    [initial-tagging initial-trackers initial-meta-pixel])
    ($ ocp
       {:title "Tagging and trackers"
        :footer ($ Stack {:direction "row"
                          :spacing 1
                          :justifyContent "flex-end"}
                   ($ Button
                      {:variant "outlined"
                       :onClick (fn [^js _event]
                                  (rf/dispatch [:ocp/close]))}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :disabled (not can-save-form)
                       :onClick (fn [^js _event]
                                  (let [new-tagging (->> form-tagging
                                                         (keep (fn [[param-name param-value]]
                                                                 (when (not (str/blank? param-name))
                                                                   {:name param-name
                                                                    :values (cond-> []
                                                                              (some? param-value)
                                                                              (conj param-value))})))
                                                         vec)

                                        patch-data (-> host-node-data
                                                       (assoc-in property/tagging-data-path new-tagging)
                                                       (assoc-in property/trackers-data-path form-trackers)
                                                       (assoc-in property/meta-pixel-data-path
                                                                 (cond-> []
                                                                   (not (str/blank? form-meta-pixel)) (conj {:value form-meta-pixel})))
                                                       ;; Assumes all the properties are under the path [:config]
                                                       (select-keys [:config]))]
                                    (rf/dispatch [::event/be-patch-node host-node-id patch-data]))
                                  (rf/dispatch [:ocp/close]))}
                      "Save"))}
       ($ tabs {:tabs (cond-> {:tagging {:label "Tagging"
                                         :content ($ tagging.view/tab-panel)}
                               :tracker {:label "Trackers"
                                         :content ($ tracker.view/tab-panel)}}
                        (= current-channel "meta")
                        (assoc :pixel {:label "Meta Pixel"
                                       :content ($ meta-pixel.view/tab-panel)}))
                :sx #js {:px 0}}))))
